import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Event } from 'src/app/models/event';

@Component({
    selector: 'app-event-card',
    templateUrl: './event-card.component.html',
    styleUrls: ['./event-card.component.scss']
})

export class EventCardComponent {
    @Input()
    get event(): Event { return this._event; }
    set event(event: Event) {
        this._event = event;
    }
    private _event: Event;

    @Input()
    get allowEventManagement(): boolean { return this._allowEventManagement; }
    set allowEventManagement(allowEventManagement: boolean) {
        this._allowEventManagement = allowEventManagement;
    }
    private _allowEventManagement = true;

    @Output() onEditRequest: EventEmitter<Event> = new EventEmitter<Event>();

    editEvent() {
        this.onEditRequest.emit(this._event);
    }

    @Output() onCancelRequest: EventEmitter<Event> = new EventEmitter<Event>();

    cancelEvent() {
        this.onCancelRequest.emit(this._event);
    }

    @Output() onViewPresenceListRequest: EventEmitter<Event> = new EventEmitter<Event>();

    viewPresenceList() {
        this.onViewPresenceListRequest.emit(this._event);
    }

    getEventDescription(event: Event) {
        return event.description?.replace(/\n/g, '<br>');
    }

    get isPast(): boolean {
        return new Date(this._event.date) < new Date();
    }
}
